import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

import img1 from "../../assets/hero.webp";

const images = [img1, img1, img1];

const HeroSection = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative h-[430px] md:h-[530px] overflow-hidden snap-section">

      <AnimatePresence mode="wait">
        <motion.img
          key={index}
          src={images[index]}
          alt="Hero Background"
          initial={{ opacity: 0, scale: 1.05 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8 }}
          className="absolute inset-0 w-full h-full"
        />
      </AnimatePresence>

      <div className="absolute inset-0 bg-black/50"></div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-6">

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="text-white text-3xl md:text-6xl font-bold mb-4"
        >
          OUR VISION
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.7 }}
          className="text-white text-sm md:text-xl max-w-[700px] leading-relaxed mb-8"
        >
          To be the front-runner in providing best in class technology solutions to Healthcare Service Providers
        </motion.p>

        <Link to="/contact#ContactForm">
          <button className="bg-[#F97316] hover:bg-[#FF7A00] text-white px-8 py-3 rounded-md font-semibold tracking-wide">
            GET STARTED!
          </button>
        </Link>

      </div>

    </section>
  );
};

export default HeroSection;